import styled from "styled-components";
import Info from "./Info";
import { useState, useEffect } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [formState, setFormState] = useState({
    name: "",
    email: "",
    message: "",
    loading: false,
    result:null
  });

  const onInputChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setFormState({ ...formState, [key]: value });
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onSbumit = async (e) => {
    e.preventDefault();

    // in the future it might be better to use mix between netlify function (which free) and resend to send emails cause resend
    // allow 3000 emails per month opposite if only 200 with emailjs but resent need to run on backend but you can fix this with
    // a free netlify function

    // this is the emailjs the old version(3), there is version(4) you can update to it.

    // Prepare email data
    const templateParams = {
      message: formState.message,
      email: formState.email,
      name: formState.name,
    };

    try {
      setFormState({ ...formState, loading: true });
      await emailjs.send(
        "service_dj1jtpe", // replace with your service ID
        "template_2qvxrdd", // replace with your template ID
        templateParams,
        "rJYQ34vAbH1T3dOy1"
      );
      setFormState({ ...formState, result: "success", loading :false });
    } catch (err) {
      setFormState({ ...formState, result: "error", loading :false });
    }
  };

  const right = (
    <div className="right">
      <div className="design1"></div>
      <div className="info_container">
        <Info />
      </div>
    </div>
  );

  return (
    <Wrapper>
      <div className="container">
        <div className="left">
          <h2 id="Contact-nous">Contact-nous</h2>
          <p>
            N'hésitez pas à nous contacter à tout moment, nous vous répondrons dès que possible.
          </p>
          <form onSubmit={onSbumit}>
            <input
              onChange={onInputChange}
              value={formState.name}
              type="text"
              placeholder="Nom"
              required={true}
              name="name"
            />
            <input
              onChange={onInputChange}
              value={formState.email}
              type="email"
              required={true}
              placeholder="Email"
              name="email"
            />
            <input
              onChange={onInputChange}
              value={formState.message}
              type="text"
              required={true}
              placeholder="Message"
              name="message"
            />
            <button type="submit">
              {formState.loading === true ? " ⏳Envoi en cours ..." : "Envoyer"}
            </button>
            <div className="result">
              {formState.loading === true
                ? " ⏳Envoi en cours ..."
                : formState.result === "success"
                ? "✅ Merci pour votre message"
                : formState.result === "error"
                ? "! Error Try again later"
                : ""}
            </div>
          </form>
        </div>

        {windowWidth >= 768 ? right : <Info />}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 60px 0;

  .container {
  }

  h2 {
    font-size: 38px;

    width: fit-content;
    margin: auto;
  }
  .left {
    padding: 0 0 40px 0;
  }
  .left > p {
    margin-top: 20px;
    color: #525252;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
  }

  form {
    display: grid;
    gap: 30px;
    margin-top: 65px;
  }
  form input {
    border: none;
    border-bottom: 1px solid #777;
    font-size: 14px;
    padding-left: 10px;
    height: 30px;
  }
  form input:focus {
    outline: none;
    border-bottom: 2px solid black;
  }
  form button {
    margin-top: 40px;
    cursor: pointer;
    padding: 10px 20px;
    background: black;
    color: white;
    border-radius: var(--radius);
  }

  .right {
    position: relative;
    width: 50%;
    max-width: 350px;
  }

  .design1 {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 100px;
    background-color: #e4e4e4;
  }

  .info_container {
    position: absolute;
    top: 50%;
    right: 50px;
    transform: translateY(-50%);
  }

  .info_container > div {
    margin-top: initial;
  }

  @media (width >= 768px) {
    .container {
      display: flex;
      justify-content: center;
      gap: 90px;
    }

    .left {
      width: 50%;
      max-width: 400px;
    }

    h2 {
      margin: initial;
    }
    .left > p {
      text-align: initial;
    }
  }

  .result {
    font-size: 16px;
    font-weight: bold;
  }
`;

export default Contact;
